// @flow
import React, { useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useMediaQuery } from 'react-responsive';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import IntroCard from 'components/molecules/introductionCard';
import './careerStyle.scss';
import { PaginationControl } from 'components/molecules/paginationControl';
import { useViewport } from 'components/templates/viewportProvider';
import { ShareButton } from 'components/atoms/shareButton';

type Props = {
  theme: string,
};
const TestimonialPage = (props: Props) => {
  const { height } = useViewport();
  const isTablet = useMediaQuery({
    query: '(max-width: 1250px) and (min-width: 578px)',
  });
  const isMobile = useMediaQuery({
    query: '(max-width: 567px)',
  });
  const [sliderRef, setSlider] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const data = props.data.testimonialData;
  if (!(props.data && props.data.testimonialData)) {
    return null;
  }
  if (!data[0]) {
    return null;
  }

  const handleSliderRef = ref => {
    setSlider(ref);
  };

  const next = () => {
    sliderRef.slickNext();
  };

  const previous = () => {
    sliderRef.slickPrev();
  };
  const lengthOfSliders = data[0].testimonial_clients
    ? data[0].testimonial_clients.length < 3
      ? 1
      : data[0].testimonial_clients.length - 1
    : '';

  return (
    <div
      className="testimonial-career-container section-container"
      style={isMobile ? { height } : {}}
      id={'testimonials'}
    >
      <Row>
        <Col xs={{ span: 11 }} md={{ span: 4, offset: 0 }} className="column">
          {data.map((item, idx) => (
            <IntroCard data={item} key={idx} />
          ))}
        </Col>
        <Col md={{ span: 8, offset: 0 }}>
          <div className="slider">
            {!isMobile ? (
              data[0] ? (
                <HorizontalCarousel
                  data={data[0]}
                  mediaPath={data[0].media_path}
                  type={
                    isTablet ? 'testimonialCareerTablet' : 'testimonialCareer'
                  }
                  cssFor={'testimonial'}
                  getActiveSlide={e => {
                    setActiveSlide(e);
                  }}
                  handleSliderRef={handleSliderRef}
                />
              ) : null
            ) : data[0] ? (
              <HorizontalCarousel
                data={data[0]}
                mediaPath={data[0].media_path}
                type={'testimonialMobileCareer'}
                cssFor="Carousel_Testimonial"
              />
            ) : null}
          </div>
        </Col>
      </Row>
      {!isMobile ? (
        <div className="section-footer">
          <PaginationControl
            className={'section-footer-item'}
            theme={'dark-theme'}
            mode={'slider'}
            currentIndex={activeSlide + 1}
            total={lengthOfSliders}
            onNextClick={next}
            onPreviousClick={previous}
            key={'17'}
          />
        </div>
      ) : null}
    </div>
  );
};
export default TestimonialPage;
